<template>
  <div>
    <v-autocomplete
      class="input__search--interesado"
      :outlined="!disabled"
      :hide-selected="true"
      ref="autocomplete"
      v-model="value"
      :search-input.sync="query"
      :hide-details="'auto'"
      :label="label"
      :persistent-hint="hint !== ''"
      :hint="this.isTotalCenter ? this.labelMacCenter : hint"
      :disabled="disabled"
      :loading="loading"
      :items="items"
      :placeholder="params.placeholder || label"
      :item-text="itemText"
      :item-value="params.value || 'id'"
      :multiple="isMultiple"
      :no-filter="true"
      :clearable="!required"
      :no-data-text="messageEmpty"
      :rules="rules"
      :hide-no-data="!isEmpty"
      @click="isEmpty = false"
      @keydown="handleSearch($event)"
      @change="handleSearchChange($event)"
    >
    <!-- :filled="disabled" -->
      <template v-if="$slots.required" v-slot:prepend-inner>
        <slot name="required"></slot>
      </template>
      <template v-slot:no-data v-if="params.nodatamessage">
        <v-list-item>
          <v-list-item-title>
            {{params.nodatamessage}}
            <strong v-if="params.extraFilter">
              {{$t('components.search.noDataMessage')}}
              <v-icon
                size="20"
              >
                mdi-filter-plus-outline
              </v-icon>
              {{$t('components.search.noDataMessageContinue')}}
          </strong>
          </v-list-item-title>
        </v-list-item>
      </template>
      <template v-slot:append >
        <v-icon v-if="!loading">mdi-magnify</v-icon>
        <v-progress-circular
          v-else
          color="primary"
          indeterminate
          size="25"
        >
        </v-progress-circular>
      </template>
      <template v-slot:append-outer
        v-if="params.extraFilter || (isMobile && isBarcodeScan)"
      >
        <v-btn
          icon
          color="primary"
          v-if="params.extraFilter"
          @click="openModal = !openModal"
        >
          <v-icon
            size="30"
            class="mb-4"
          >
            mdi-filter-plus-outline
          </v-icon>
        </v-btn>
        <ExtendedSearch
          v-if="openModal && params.extraFilter"
          :filtersSearch="evalParam(params.extraFilter)"
          :filters="evalParam(params.filters)"
          :params="params"
          :title="label"
          @close="openModal = false"
        >
        </ExtendedSearch>
      </template>
    </v-autocomplete>

    <template v-if="itemsList.length > 0">
        <v-chip
          v-for="(item, i) in itemsList"
          :key="i"
          class="ma-2"
          :model-value="true"
        >
          {{ item }}
          <span class="btn__delete__interesado" @click="deleteItem(item)">
            <v-icon>mdi-delete</v-icon>
          </span>
        </v-chip>
      </template>
  </div>
</template>

<script>
/* eslint-disable no-param-reassign */
import Search from '../field-types/Search.vue';

const COMPONENT_MATCH_FIELDS = ['zdni', 'userid', 'first_name', 'middle_name', 'last_name'];

function getDelimiter(val) {
  return val.includes(',') ? ',' : ' ';
}

export default {
  name: 'ContactSearchMultiple',
  extends: Search,
  props: {
    cancelable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      itemsList: [],
    };
  },
  methods: {
    matchToFilters(queryValue) {
      const { match } = this.params;

      if (queryValue.includes(',') || !queryValue.includes(' ')) {
        const query = queryValue.trim().replace(/ +/i, ' ').replace(/ /i, '%').toUpperCase();
        const delimiter = getDelimiter(queryValue);

        // if query value has some ','
        if (queryValue.includes(delimiter)) {
          const splitted = queryValue.split(delimiter);
          const numberOfOcurrences = (queryValue.match(new RegExp(delimiter, 'g')) || []).length;
          let keys;
          switch (numberOfOcurrences) {
          case 3:
            keys = ['middle_name', 'last_name', 'first_name', 'location.name'];
            break;
          case 2:
            keys = ['middle_name', 'last_name', 'first_name'];
            break;
          case 1:
          default:
            keys = ['middle_name', 'last_name'];
          }
          return [keys.reduce((acum, key, idx) => {
            acum[key] = { $regex: `%${splitted[idx].trim().toUpperCase()}%` };
            return acum;
          }, {})];
        }

        // get match param for extra matching fields
        const matchP = (typeof match === 'string' ? match.split(',') : [])
          .filter((field) => !COMPONENT_MATCH_FIELDS.includes(field))
          .concat(COMPONENT_MATCH_FIELDS);

        return matchP.map((param) => ({ [param]: { $regex: `%${query}%` } }));
      }

      const fullNameQuery = `%${queryValue.replace(/ /g, '%').toUpperCase()}%`;
      return {
        full_name_contact_search: { $regex: fullNameQuery },
      };
    },
    handleSearchChange(evt) {
      this.emitInputData(evt);
      this.query = '';
      const listAux = [];
      if (Array.isArray(evt)) {
        // eslint-disable-next-line array-callback-return
        this.value.map((item) => {
          listAux.push(item);
        });
      } else {
        listAux.push(evt);
      }
      this.itemsList = listAux;
    },
    deleteItem(name) {
      if (typeof this.value === 'string') {
        this.value = null;
        this.itemsList = [];
      } else {
        const index = this.value.indexOf(name);
        const indexL = this.itemsList.indexOf(name);
        this.value.splice(index, 1);
        this.value = this.value.filter((item) => item !== name);
        this.itemsList.splice(indexL, 1);
      }
    },
    evalParam(param, v) {
      const str = typeof param === 'function' ? param({ value: v }) : param;
      try {
        return JSON.parse(str || '{}');
      } catch (ex) {
        return str;
      }
    },

  },
};
</script>
<style>
.card__container {
  padding: 0.5rem 1rem;
}
.btn__delete__interesado {
  cursor: pointer;
}
.container__contactSearch {
  border: 1px solid #afadad;
  position: relative;
  padding: 1.5rem;
  margin-top: 1rem;
}
.input__search--interesado {
  margin-top: 1rem !important;
}
</style>
